/** Import job states in order (CONTEXT.md: Import). */
export const IMPORT_STATUSES = [
  'queued',
  'fetching',
  'extracting',
  'matching',
  'done',
  'failed',
] as const;
export type ImportStatus = (typeof IMPORT_STATUSES)[number];

export const IMPORT_KINDS = ['url', 'text', 'image', 'notion'] as const;
export type ImportKind = (typeof IMPORT_KINDS)[number];

/** What the user gave us. */
export interface ImportInput {
  url?: string;
  text?: string;
  imageIds?: string[];
  /** Notion migration (P3.08): the page it came from, so a re-run skips it. */
  notionPageId?: string;
}
